export default function NoContent(p){
    return (
   <div className="_noContentDV">
      {p.value}
   </div>
    );

}